import React, { useState, useEffect } from "react";

function Script() {
    const [direction, setDirection] = useState(() => {
        // Retrieve the saved direction from localStorage or default to "ltr"
        return localStorage.getItem("pageDirection") || "ltr";
    });

    useEffect(() => {
        // Apply the saved direction to the body when the component mounts
        document.body.setAttribute("dir", direction);

        // Save the direction in localStorage whenever it changes
        localStorage.setItem("pageDirection", direction);
    }, [direction]);

    const toggleDirection = () => {
        // Toggle between "ltr" and "rtl"
        setDirection((prevDirection) => (prevDirection === "ltr" ? "rtl" : "ltr"));
    };
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Show or hide the button based on scroll position
            setIsVisible(window.scrollY > 0);
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Smooth scrolling
        });
    };
    return (
        <>
            <div className="fixed-button-wrapper">
                <div className="rtl-ltr-switcher-btn" onClick={toggleDirection}>
                    <span className={`rtl ${direction === "rtl" ? "show" : ""}`}>
                        <span>RTL</span>
                    </span>
                    <span className={`ltr ${direction === "ltr" ? "show" : ""}`}>
                        <span>LTR</span>
                    </span>
                </div>
                {/* progress area start */}
                <div id="backToTop" className={`back-to-top ${isVisible ? "visible" : ""}`} onClick={scrollToTop}
                    style={{
                        transition: "all 0.4s ease",
                        marginBottom: isVisible ? "0" : "-80px",
                        opacity: isVisible ? "1" : "0",
                    }}
                >
                    <div className="inner">↑</div>
                </div>
                {/* progress area end */}
            </div>
        </>

    )
}

export default Script